import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import cn from 'classnames'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export type RetryPaymentProps = {
  text: string
  className?: string
}

///////////////////////////////////////////////////////////////////////////////

export const RetryPayment: FC<RetryPaymentProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {text, className} = props

  const retryPayment = async () => {
    await api.retryPayment()
    await api.ui.scrollToTop()
  }

  if (!text) {
    return null
  }

  return (
    <div className={cn('retry-payment', className)}>
      <div className="main">
        <button type="button" onClick={retryPayment}>
          <span className="link">{text}</span>
        </button>
      </div>
    </div>
  )
})
